var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"text--disabled text-decoration-underline",attrs:{"to":_vm.versionPath}},[_c('strong',[_vm._v(_vm._s(_vm.versionsCount || 0))]),_vm._v("\n  "+_vm._s(_vm.$tc(_vm.translateKey, _vm.versionsCount))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }